import { getFeatureConfig } from '@luna/feature-config';
import { DateFormat, formatDate } from '@luna/date';

import type { ExportFilesFilterParams } from './ExportFilesFilterParams';

type ExportDateFilters = Pick<
    ExportFilesFilterParams,
    'startDate' | 'endDate' | 'createdFrom' | 'createdTo'
>;

export function buildExportDateParams(dates: ExportDateFilters): ExportDateFilters {
    const withCreatedDateParams = getFeatureConfig(
        ({ transactions }) => transactions.exportCenter.withCreatedDateParams,
    );

    return withCreatedDateParams
        ? buildCreatedDateParams(dates)
        : buildTransactionDateParams(dates);
}

function buildCreatedDateParams({
    startDate,
    endDate,
    createdFrom,
    createdTo,
}: ExportDateFilters): ExportDateFilters {
    return {
        createdFrom: formatDateTime(createdFrom ?? startDate),
        createdTo: formatDateTime(createdTo ?? endDate),
    };
}

function buildTransactionDateParams({
    startDate,
    endDate,
    createdFrom,
    createdTo,
}: ExportDateFilters): ExportDateFilters {
    return {
        startDate: formatDateOnly(startDate),
        endDate: formatDateOnly(endDate),
        createdFrom: formatDateTime(createdFrom),
        createdTo: formatDateTime(createdTo),
    };
}

function formatDateOnly(date?: string): string | undefined {
    return date ? formatDate(date, DateFormat.ISO_DATE_FORMAT) : undefined;
}

function formatDateTime(date?: string): string | undefined {
    return date ? formatDate(date, DateFormat.ISO_DATE_TIME_FORMAT) : undefined;
}
